module.exports = __webpack_public_path__ + "static/media/LP_About_Fullarticle.Arrow.f3c570be.svg";